import type { TransactionStatus } from "@/forwards2/forwardsTypes";

const SHIPPED_STATUSES: TransactionStatus[] = ["DELIVERED", "COMPLETED"];

/**
 * `commitment_predicates.delivery_frozen`: a shipped delivery is history, and so is a voided one
 * (null status) — a cancelled deal's delivery has no transaction left to price or move volume into.
 */
export const isDeliveryFrozen = (
  transactionStatus: TransactionStatus | null
): boolean =>
  transactionStatus === null || isDeliveryShipped(transactionStatus);

/** `commitment_predicates.SHIPPED_TRANSACTION_STATUSES`: the transaction has gone out to the buyer. */
export const isDeliveryShipped = (
  transactionStatus: TransactionStatus | null
): boolean =>
  transactionStatus !== null && SHIPPED_STATUSES.includes(transactionStatus);
